<div style="flex:1; height: 3.5em; margin: -1.5em -1em -1em -1em;" *ngIf="files.length === 0" (click)="!(to.disabled || to.readonly) && fileInput.click()">
</div>
<mat-list style="padding:0;" *ngIf="loaded; else fileSpinner">
  <mat-list-item *ngFor="let file of files; let i = index" style="height:3em;">
    <ng-template [ngIf]="file.progress?.status === uploadStatus.Queue">
      <mat-icon mat-list-icon style="margin-right:10px;">cloud_queue</mat-icon>
      <div style="flex:1;">
        <div mat-line>{{ file.name }}</div>
        <div mat-line>{{ 'FORM.CONTROL.FILE_UPLOAD.QUEUED_LABEL' | translate }}</div>
      </div>
    </ng-template>
    <ng-template [ngIf]="file.progress?.status === uploadStatus.Uploading">
      <mat-icon mat-list-icon style="margin-right:10px;">cloud_upload</mat-icon>
      <div style="flex:1;">
        <div mat-line>{{ file.name }}</div>
        <div mat-line>{{ 'FORM.CONTROL.FILE_UPLOAD.ESTIMATE_LABEL' | translate }} {{ file.progress?.etaHuman }}</div>
      </div>
    </ng-template>
    <ng-template [ngIf]="file.progress?.status === uploadStatus.Done">
      <mat-icon mat-list-icon style="margin-right:10px;">cloud_done</mat-icon>
      <div style="flex:1;">
        <div mat-line [ngClass]="enableDownload[i] ? 'download' : '' " (click)="download(file, enableDownload[i])">{{ file.name }}</div>
        <div mat-line>{{ file.type }} ({{ humanizeBytes(file.size) }})</div>
      </div>
    </ng-template>
    <ng-template [ngIf]="file.progress?.status === uploadStatus.Cancelled && file.responseStatus === 500">
      <mat-icon mat-list-icon style="margin-right:10px;">error</mat-icon>
      <div style="flex:1;">
        <div mat-line>{{ file.name }}</div>
        <div mat-line>{{ 'FORM.CONTROL.FILE_UPLOAD.FAILED_MESSAGE' | translate }}</div>
      </div>
    </ng-template>
    <ng-template [ngIf]="file.progress?.status === uploadStatus.Cancelled && file.responseStatus !== 500">
      <mat-icon mat-list-icon style="margin-right:10px;">cancel</mat-icon>
      <div style="flex:1;">
        <div mat-line>{{ file.name }}</div>
        <div mat-line>{{ 'FORM.CONTROL.FILE_UPLOAD.CANCELLED_LABEL' | translate }}</div>
      </div>
    </ng-template>
    <button mat-icon-button type="button" aria-label="Remove file" (click)="removeFile(file);" [disabled]="to.disabled || to.readonly">
      <mat-icon>delete</mat-icon>
    </button>
  </mat-list-item>
</mat-list>
<button *ngIf="files.length > 0 && loaded" mat-mini-fab type="button" aria-label="Upload more files"
        [disabled]="to.disabled || to.readonly"
        style="z-index: 2; position: absolute; top: -16px; right: -16px;" (click)="fileInput.focus(); fileInput.click()">
  <mat-icon>add</mat-icon>
</button>
<input type="file" style="opacity: 0; position:absolute; top:0; left: 0; height:1px; width:1px;" #fileInput ngFileSelect [options]="options" (uploadOutput)="onUploadOutput($event)"
       [uploadInput]="uploadInput"
       [multiple]="to.isMultiSelect"
       [formlyAttributes]="field"
       [disabled]="to.disabled || to.readonly"
       (focus)="onFocusIn()"
       (blur)="onFocusOut()">
<input type="hidden" style="opacity: 0; position:absolute; top:0; left: 0; height:1px; width:1px;" [formControl]="formControl">
<mat-error *ngIf="errorMessage">{{errorMessage}}</mat-error>

<ng-template #fileSpinner>
  <div class="fileSpinner">
    <svg width="40px" height="40px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
      <circle fill="none" stroke-width="4" stroke-linecap="round" cx="33" cy="33" r="30" class="circle"></circle>
    </svg>
  </div>
</ng-template>
